export const SOCIAL_MEDIA_LINKS = {
	FACEBOOK: "https://pt-br.facebook.com/ToyotaKyoto",
	INSTAGRAM: "https://www.instagram.com/kyototoyota/",
	LINKEDIN: "https://br.linkedin.com/company/kyototoyota",
	YOUTUBE: "https://www.youtube.com/@kyototoyota7462",
} as const;

export type SocialMediaItem = {
	src: string;
	href: string;
	alt: string;
};

export const FOOTER_SOCIAL_MEDIA: SocialMediaItem[] = [
	{
		src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/SVG/item=face,%20status=default.svg",
		href: SOCIAL_MEDIA_LINKS.FACEBOOK,
		alt: "Facebook",
	},
	{
		src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/SVG/item=insta,%20status=default.svg",
		href: SOCIAL_MEDIA_LINKS.INSTAGRAM,
		alt: "Instagram",
	},
	{
		src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/SVG/item=linke,%20status=default.svg",
		href: SOCIAL_MEDIA_LINKS.LINKEDIN,
		alt: "LinkedIn",
	},
	{
		src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/SVG/item=youtube,%20status=default.svg",
		href: SOCIAL_MEDIA_LINKS.YOUTUBE,
		alt: "YouTube",
	},
];

export const PROGRAMA_INDICACAO_SOCIAL_MEDIA: SocialMediaItem[] = [
	{
		src: "/images/assets-programa-indicacao/facebook-f.png",
		href: SOCIAL_MEDIA_LINKS.FACEBOOK,
		alt: "Facebook",
	},
	{
		src: "/images/assets-programa-indicacao/instagram.png",
		href: SOCIAL_MEDIA_LINKS.INSTAGRAM,
		alt: "Instagram",
	},
	{
		src: "/images/assets-programa-indicacao/linkedin-in.png",
		href: SOCIAL_MEDIA_LINKS.LINKEDIN,
		alt: "LinkedIn",
	},
	{
		src: "/images/assets-programa-indicacao/youtube.png",
		href: SOCIAL_MEDIA_LINKS.YOUTUBE,
		alt: "YouTube",
	},
];
